export default {
  en: {
    tabs: {
      overview: 'Overview',
      suppliers: 'Suppliers',
      about: 'About',
    },
    dataTableColumns: {
      name: 'Supplier name',
      compliance: 'Compliance',
      reviewState: 'Review status',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'PII',
      assignedUsers: 'Assigned',
      dateAdded: 'Date added',
      companyNumber: 'Company number',
      country: 'Country',
      managed: 'RL managed',
      sector: 'Sector',
      website: 'Website',
      exemptionsApplied: 'Exemptions applied',
      nonComplianceApplied: 'Non-compliances applied',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      reviewExpiresAt: 'Review expiry',
      numRisks: 'Open risks',
    },
    filterAttributes: {
      name: 'Name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      managed: 'RL managed',
      managedTrue: 'is managed',
      managedFalse: 'is not managed',
      percentageCompliance: 'Compliance',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'Holds PII',
      reviewState: 'Review status',
      reviewModifiedAt: 'Review last modified',
      reviewExpiresAt: 'Review expiry',
      createdAt: 'Date added',
      sectorID: 'Sector',
      assignedUsers: 'Assigned users',
      numExemptionsApplied: 'Number of exemptions applied',
      numNonComplianceApplied: 'Number of non compliances applied',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      numRisks: 'Open risks',
      dateAdded: 'Date added',
    },
    placeholders: {
      emptyTitle: 'Sub-entity suppliers',
      emptyDescription: 'No sub-entity suppliers could be found',
      errorTitle: 'Sub-entity suppliers',
      errorDescription: 'Failed fetching sub-entity suppliers',
    },
    misc: {
      managedLabel: 'RL managed',
      managedDescription: 'This profile has been created and is managed by Risk Ledger.',
      filterResultsSuppliers: '{count} suppliers | {count} supplier | {count} suppliers',
      filterResultsOutOf: '{0} out of {1}',
      entityName: 'Suppliers',
      export: 'Export',
      exportError: 'There was an error attempting to export the supplier list.',
    },
    totalSuppliers: {
      title: 'Total suppliers',
    },
    averageCompliance: {
      title: 'Average compliance',
    },
    minor: 'Minor',
    important: 'Important',
    critical: 'Critical',
    unknown: 'Unknown',
    overviewFailed: 'Failed to get overview data. Please retry or contact Risk Ledger support.',
    retry: 'Retry',
  },
};
